import React from "react";
import { legalLinks } from "../lib/navLinks";
import { NavLink } from "react-router";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa6";
export default function MobileFooter() {
  return (
    <footer className="flex w-full flex-col items-center justify-center gap-3 bg-primaryColor pb-2 pt-4 lg:hidden">
      <NavLink
        to={"/contact"}
        className={({ isActive }) =>
          `${isActive && "text-secondaryHover"} text-sm text-secondaryColor`
        }
      >
        Contact
      </NavLink>
      <ul>
        <li className="flex justify-center gap-2 md:gap-3">
          <a
            href="https://www.linkedin.com/company/accesscvlimited"
            target="blank"
          >
            <FaLinkedin className="text-sm text-secondaryColor md:text-base" />
          </a>
          <a href="https://www.instagram.com/accesscvlimited/" target="blank">
            <FaInstagram className="text-sm text-secondaryColor md:text-base" />
          </a>
          <a href="https://www.facebook.com/AccessCVOffshore/" target="blank">
            <FaFacebook className="text-sm text-secondaryColor md:text-base" />
          </a>
        </li>
      </ul>
      <ul className="flex gap-2">
        {legalLinks.map((link, index) => {
          return (
            <li key={index}>
              <NavLink
                to={link.url}
                className={({ isActive }) =>
                  `${isActive && "text-gray-200"} text-sm text-white`
                }
              >
                {link.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
      <p className="text-center text-sm text-white">
        Designed by{" "}
        <a
          href="https://beartech.dev/"
          target="blank"
          className="text-secondaryColor hover:text-secondaryHover"
        >
          BearTech.dev
        </a>{" "}
        in UK
      </p>
      <p className="text-sm text-white">
        Copyright &copy; 2025 Access CV Limited
      </p>
    </footer>
  );
}
